const initialState = {
  order_id: JSON.parse(localStorage.getItem('order_id')) || null,
};

const orderIdReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'SET_ORDER_ID':
          localStorage.setItem('order_id', JSON.stringify(action.payload));
          return {
              ...state,
              order_id: action.payload,
          };
      default:
          return state;
  }
};

export default orderIdReducer;